export default "__VITE_ASSET__DquZG40O__ 100w";